/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import colorsMixins from '../../../frontend/views/utils/colorsManipulation.js'

// importing this here (outside of the style tag) is important,
// because this is what results in the global main.css file
// being placed in dist/assets/css/main.css, which is included
// by index.html
import '../../../frontend/assets/style/main.scss'
import { mapGetters } from 'vuex'

const __vue_script__ = ({
  name: 'AppStyles',

  mixins: [colorsMixins],

  computed: {
    ...mapGetters([
      'fontSize',
      'colors'
    ]),
    softTone () {
      return this.colors.theme === 'dark' ? 0.1 : -0.1
    }
  }
}        )

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-style',[_vm._v(":root {\n  --primary_0: "+_vm._s(_vm.colors.primary_0)+";\n  --primary_0_1: "+_vm._s(_vm.lightenDarkenColor(_vm.colors.primary_0, _vm.softTone))+";\n  --primary_1: "+_vm._s(_vm.colors.primary_1)+";\n  --primary_2: "+_vm._s(_vm.colors.primary_2)+";\n  --success_0: "+_vm._s(_vm.colors.success_0)+";\n  --success_0_1: "+_vm._s(_vm.lightenDarkenColor(_vm.colors.success_0, _vm.softTone))+";\n  --success_1: "+_vm._s(_vm.colors.success_1)+";\n  --success_2: "+_vm._s(_vm.colors.success_2)+";\n  --warning_0: "+_vm._s(_vm.colors.warning_0)+";\n  --warning_0_1: "+_vm._s(_vm.lightenDarkenColor(_vm.colors.warning_0, _vm.softTone))+";\n  --warning_0_text: "+_vm._s(_vm.colors.warning_0_text)+";\n  --warning_0_2: "+_vm._s(_vm.colors.warning_0_2)+";\n  --warning_1: "+_vm._s(_vm.colors.warning_1)+";\n  --warning_2: "+_vm._s(_vm.colors.warning_2)+";\n  --danger_0: "+_vm._s(_vm.colors.danger_0)+";\n  --danger_0_1: "+_vm._s(_vm.lightenDarkenColor(_vm.colors.danger_0, _vm.softTone))+";\n  --danger_1: "+_vm._s(_vm.colors.danger_1)+";\n  --danger_2: "+_vm._s(_vm.colors.danger_2)+";\n  --danger_3: "+_vm._s(_vm.colors.danger_3)+";\n  --text_0: "+_vm._s(_vm.colors.text_0)+";\n  --text_1: "+_vm._s(_vm.colors.text_1)+";\n  --general_0: "+_vm._s(_vm.colors.general_0)+";\n  --general_1: "+_vm._s(_vm.colors.general_1)+";\n  --general_1_opacity_6: "+_vm._s(_vm.hexToRgbA(_vm.colors.general_1, 0.6))+";\n  --general_2: "+_vm._s(_vm.colors.general_2)+";\n  --background_0: "+_vm._s(_vm.colors.background_0)+";\n  --background_0_opacity_0: "+_vm._s(_vm.hexToRgbA(_vm.colors.background_0, 0))+";\n  --text-size: "+_vm._s(_vm.fontSize)+"px;\n}")])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "script>\n"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__